import { Paper, Stack, Typography } from "@mui/material";
import React, { ReactElement } from "react";
import Highlighter from "react-highlight-words";

interface SamplesProps {
  sampleSelectedCallback?: (selectedSample: string) => void;
}

const Samples = (props: SamplesProps): ReactElement => {
  const { sampleSelectedCallback } = props;

  const SAMPLES: string[] = [
    "Será que tenho que pagar os [MASK] este ano.",
    "Qual será a previsão do [MASK] para amanhã.",
    "Sempre que chove apanho uma [MASK].",
    "Um [MASK] é um objeto redondo.",
  ];

  return (
    <Stack spacing={1.25}>
      {SAMPLES.map((sample, index) => {
        return (
          <Paper
            key={"sample-" + index}
            variant="elevation"
            elevation={4}
            sx={{
              padding: 1.5,
              border: "1px solid",
              borderColor: "primary.light",
              backgroundColor: "background.paper",
              cursor: "pointer",
              transition: "box-shadow 0.2s ease, transform 0.2s ease",
              "&:hover": {
                boxShadow: 6,
                transform: "translateY(-2px)",
              },
            }}
            onClick={() => {
              sampleSelectedCallback && sampleSelectedCallback(sample);
            }}
          >
            <Typography variant="caption" sx={{ fontWeight: 700, color: "primary.main" }}>
              Sample {index + 1}
            </Typography>
            <Typography variant="body2">
              <Highlighter
                searchWords={["[MASK]"]}
                autoEscape={true}
                textToHighlight={sample}
              />
            </Typography>
          </Paper>
        );
      })}
    </Stack>
  );
};

export default Samples;
